import { c as _c } from "react/compiler-runtime";
import uniqueId from 'lodash/uniqueId';
import { useTranslation } from 'react-i18next';
import type { FinancialDataItem } from '../../types';
import FinancialPermissions from './financial-permissions/financial-permissions';
const FinancialDataDetails = t0 => {
  const $ = _c(14);
  const {
    cards,
    bankAccounts
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "events.userData"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("security-logs", t1);
  let t2;
  if ($[1] !== cards || $[2] !== t) {
    let t3;
    if ($[4] !== t) {
      t3 = card => <FinancialPermissions key={uniqueId()} title={`${card.name} (${t(_temp)})`} permissions={card.fields} />;
      $[4] = t;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    t2 = cards.map(t3);
    $[1] = cards;
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[6] !== bankAccounts || $[7] !== t) {
    let t4;
    if ($[9] !== t) {
      t4 = bankAccount => <FinancialPermissions key={uniqueId()} title={`${bankAccount.name} (${t(_temp2)})`} permissions={bankAccount.fields} />;
      $[9] = t;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    t3 = bankAccounts.map(t4);
    $[6] = bankAccounts;
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[11] !== t2 || $[12] !== t3) {
    t4 = <div className="flex flex-col gap-4 max-h-[500px] overflow-y-auto">{t2}{t3}</div>;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
};
export default FinancialDataDetails;
function _temp($) {
  return $.card;
}
function _temp2($_0) {
  return $_0.bankAccount;
}